import React, { useState, useEffect } from "react";
import Container from '@mui/material/Container';
import Bottomright from '../assets/images/first-page/bottom-right-gradient.svg';
import Topleft from '../assets/images/first-page/top-left-gradient.svg';
import {
    TextField,
    Button,
    IconButton,
    Typography,
    Box,
    FormControl,
    InputLabel,
    OutlinedInput,
    InputAdornment,
    Stack,
} from "@mui/material";
import Logo from '../assets/images/common/logo.png';
import Dollarcoin from '../assets/images/bonus/dolar-coin.png';
import Topgradient from '../assets/images/bonus/top-gradient-big.svg';

import Chatgpt from '../assets/images/common/chatgpt-logo.png';
import Gemini from '../assets/images/common/gemini-logo.png';
import Gemma from '../assets/images/common/gemma-logo.png';
import Mistral from '../assets/images/common/mistral-logo.png';
import Websearch from '../assets/images/common/web-search-logo.png';
import Tick from '../assets/images/common/tick-icon.png';
import { Wallet } from "../icons/icons";


import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';

function Bonus() {


    const navigate = useNavigate();

    const handleStartTokens = () => {
        navigate('/welcome'); // Navigate to the new page
    };
    return (
        <>
            <Box className="welcome-page" sx={{ position: 'relative', zIndex: '9999' }}>
                <Container>
                    <Box >
                        <img src={Logo} alt="logo" />
                    </Box>
                    <Grid container spacing={'24px'} justifyContent={'center'}>
                        <Grid size={{ xs: 8, xl: 6 }}>
                            <Box sx={{ py: { xs: '40px', xl: '150px' } }}>
                                <Grid container spacing={'30px'} justifyContent={'center'} alignItems={'stretch'}>
                                    <Grid size={{ xs: 6, md: 6 }}>
                                        <Box className="gift-bonus">
                                        </Box>
                                    </Grid>
                                    <Grid size={{ xs: 6, md: 6 }}>
                                        <Stack direction={'column'} justifyContent={'center'} alignItems={'start'} sx={{ height: '100%' }}>
                                            <Box sx={{ py: { xs: '14px', xl: '24px' } }}>
                                                <Typography variant="h1" sx={{ color: '#fff', fontSize: { xs: '60px', xl: '80px' }, fontWeight: '700' }} fullWidth>
                                                    $5
                                                </Typography>
                                                <Typography variant="h1" sx={{ color: '#fff', fontSize: { xs: '30px', xl: '40px' }, fontWeight: '700', my: '12px' }} fullWidth>
                                                    Congratulations!!
                                                </Typography>
                                                <Typography variant="h1" sx={{ color: '#fff', fontSize: '20px', fontWeight: '400' }} fullWidth>
                                                    Bonus Amount has been added to your wallet
                                                </Typography>
                                            </Box>
                                            <Box sx={{ pt: { xs: '18px', xl: '24px' } }}>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleStartTokens}
                                                    sx={{ mb: { xs: 0, xl: 2 }, p: { xs: '6px 30px', xl: '15px 50px' }, width: 'auto', backgroundColor: 'primary.Main', fontSize: '18px', fontWeight: '500', borderRadius: '50px', height: 'auto' }}
                                                >
                                                    Start using Tokens
                                                </Button>
                                            </Box>
                                        </Stack>

                                    </Grid>
                                </Grid>
                            </Box>

                            <Box sx={{ backgroundColor: '#0A43AE', p: '16px', borderRadius: '8px', position: 'relative' }}>
                                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Box>
                                        <Typography variant="h1" sx={{ color: '#fff', fontSize: { xs: '18px', xl: '22px' }, fontWeight: '700' }} fullWidth>
                                            Want to unlock more <br></br>
                                            Tokens?
                                        </Typography>
                                    </Box>

                                    <Stack direction={'row'} alignItems={'center'} sx={{ p: '10px 20px', background: '#fff', borderRadius: '50px' }}>

                                        <Wallet />

                                        <Typography variant="h1" sx={{ color: '#0A43AE', fontSize: '16px', ml: '8px', fontWeight: '700' }} >
                                            Top Up Wallet
                                        </Typography>
                                    </Stack>
                                </Stack>
                                <Box sx={{ position: 'absolute', top: '-40px', right: '-18px' }}>

                                    <img src={Dollarcoin} alt="gradient" />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>

                </Container>

                <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: '-1', textAlign: 'center', height: '60%' }}>
                    <img src={Topgradient} alt="gradient" className="top-big-circle" />
                </Box>
                <Box sx={{ position: 'absolute', bottom: 0, right: 0, zIndex: '-1' }} >
                    <img src={Bottomright} alt="gradient" />
                </Box>

            </Box>

        </>

    );
}

export default Bonus;